import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { Component, Fragment, render } from "preact";
import { PaymentMethodComponent } from "../PaymentMethodComponent";
class LinkTypePaymentMethodComponent extends Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (_jsxs(Fragment, { children: [_jsxs("h4", Object.assign({ class: "content__title" }, { children: [_jsx("span", { class: "heading" }, void 0), "\u304A\u652F\u6255\u3044\u60C5\u5831"] }), void 0),
                _jsx(PaymentMethodComponent, Object.assign({}, this.props), void 0)] }, void 0));
    }
}
window.addEventListener('load', () => {
    const mountTo = document.querySelector('#LinkTypePaymentMethodComponent');
    if (mountTo) {
        const storeId = Number(mountTo.getAttribute('data-store-id'));
        const storeType = mountTo.getAttribute('data-store-type') ?? '';
        const cartType = mountTo.getAttribute('data-cart-type') ?? 'CART';
        render(_jsx(LinkTypePaymentMethodComponent, { storeId: storeId, storeType: storeType, cartType: cartType }, void 0), mountTo);
    }
});
